import { ISlideInContent } from "ui";
import UserGuide from "./UserGuide";
import SelectTourStep from "./SelectTourStep";
export const USER_GUIDES: ISlideInContent = {
    id: "USER_GUIDES",
    header: "User Guides",
    content: UserGuide
}

export const SELECT_TOUR_STEP: ISlideInContent = {
    id: "SELECT_TOUR_STEP",
    header: "Guided Tutorials",
    content: SelectTourStep
}